// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1lUeh","assignButton":"CreateEditEquipmentSchedule_assignButton__18fea"};